import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Input, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ColaboradorDadosPrincipaisComponent } from './dados-principais/dados-principais.component';
import { ColaboradorDocumentacaoComponent } from './documentacao/documentacao.component';
import { ColaboradorEmpregadorComponent } from './empregador/empregador.component';
import { ColaboradorPagamentoComponent } from './pagamento/pagamento.component';
import { ColaboradorEstrangeiroComponent } from './estrangeiro/estrangeiro.component';
import { ColaboradorAnexarDocumentoComponent } from './anexar-documento/anexar-documento.component';
import { UsuarioColaboradorTipoEnum, ColaboradorStatusEnum, TipoRegistroEnum,} from "src/app/@core/@enum/enum";

@Component({
  selector: 'app-colaborador',
  templateUrl: './colaborador.component.html',
  styleUrls: ['./colaborador.component.scss']
})
export class ColaboradorComponent implements OnInit {

  constructor(
    private location: Location,
    private router: Router,
    private resolver: ComponentFactoryResolver,
  ) { }

  @ViewChild('tabRouterDadoPrincipal', { static: true, read: ViewContainerRef }) tabRouterDadoPrincipal: ViewContainerRef;
  @ViewChild('tabRouterDadoPrincipalDiv', { static: true }) tabRouterDadoPrincipalDiv: ElementRef;
  factoryDadoPrincipal: any;
  objDadoPrincipal: any;

  @ViewChild('tabRouterDocumentacao', { static: true, read: ViewContainerRef }) tabRouterDocumentacao: ViewContainerRef;
  @ViewChild('tabRouterDocumentacaoDiv', { static: true }) tabRouterDocumentacaoDiv: ElementRef;
  factoryDocumentacao: any;
  objDocumentacao: any;

  @ViewChild('tabRouterEmpregador', { static: true, read: ViewContainerRef }) tabRouterEmpregador: ViewContainerRef;
  @ViewChild('tabRouterEmpregadorDiv', { static: true }) tabRouterEmpregadorDiv: ElementRef;
  factoryEmpregador: any;
  objEmpregador: any;

  @ViewChild('tabRouterPagamento', { static: true, read: ViewContainerRef }) tabRouterPagamento: ViewContainerRef;
  @ViewChild('tabRouterPagamentoDiv', { static: true }) tabRouterPagamentoDiv: ElementRef;
  factoryPagamento: any;
  objPagamento: any;

  @ViewChild('tabRouterEstrangeiro', { static: true, read: ViewContainerRef }) tabRouterEstrangeiro: ViewContainerRef;
  @ViewChild('tabRouterEstrangeiroDiv', { static: true }) tabRouterEstrangeiroDiv: ElementRef;
  factoryEstrangeiro: any;
  objEstrangeiro: any;

  @ViewChild('tabRouterAnexarDocumentos', { static: true, read: ViewContainerRef }) tabRouterAnexarDocumentos: ViewContainerRef;
  @ViewChild('tabRouterAnexarDocumentosDiv', { static: true }) tabRouterAnexarDocumentosDiv: ElementRef;
  factoryAnexarDocumentos: any;
  objAnexarDocumentos: any;

  ehRH: boolean = false;
  
  ngOnInit() {

    this.changeTab('dadosPrincipais');
    const userLogged = JSON.parse(sessionStorage.getItem("currentUser"));
    this.ehRH = userLogged && userLogged.tipoUsuario == "RH";
  }

  changeTab(tab) {
    let component;
    $('li').removeClass('active');
    $(`#${tab}`).addClass('active');
    switch (tab) {
      case 'dadosPrincipais':
        component = ColaboradorDadosPrincipaisComponent;
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'none';
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'none';
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'none';
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'none';
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objDadoPrincipal) {
            this.factoryDadoPrincipal = this.resolver.resolveComponentFactory(component);
            this.tabRouterDadoPrincipal.clear();
            this.objDadoPrincipal = this.tabRouterDadoPrincipal.createComponent(this.factoryDadoPrincipal);
          }
        }
        break;
      case 'documentacao':
        component = ColaboradorDocumentacaoComponent;
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'none';
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'none';
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'none';
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'none';
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objDocumentacao) {
            this.factoryDocumentacao = this.resolver.resolveComponentFactory(component);
            this.tabRouterDocumentacao.clear();
            this.objDocumentacao = this.tabRouterDocumentacao.createComponent(this.factoryDocumentacao);
          }
        }
        break;
      case 'empregador':
        component = ColaboradorEmpregadorComponent;
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'none';
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'none';
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'none';
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'none';
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objEmpregador) {
            this.factoryEmpregador = this.resolver.resolveComponentFactory(component);
            this.tabRouterEmpregador.clear();
            this.objEmpregador = this.tabRouterEmpregador.createComponent(this.factoryEmpregador);
          }
        }
        break;
      case 'pagamento':
        component = ColaboradorPagamentoComponent;
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'none';
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'none';
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'none';
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'none';
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objPagamento) {
            this.factoryPagamento = this.resolver.resolveComponentFactory(component);
            this.tabRouterPagamento.clear();
            this.objPagamento = this.tabRouterPagamento.createComponent(this.factoryPagamento);
          }
        }
        break;
      case 'estrangeiro':
        component = ColaboradorEstrangeiroComponent;
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'none';
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'none';
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'none';
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'none';
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objEstrangeiro) {
            this.factoryEstrangeiro = this.resolver.resolveComponentFactory(component);
            this.tabRouterEstrangeiro.clear();
            this.objEstrangeiro = this.tabRouterEstrangeiro.createComponent(this.factoryEstrangeiro);
          }
        }
        break;
      case 'anexarDocumentos':
        component = ColaboradorAnexarDocumentoComponent;
        this.tabRouterAnexarDocumentosDiv.nativeElement.style.display = 'inline';
        // Oculta outras abas
        this.tabRouterDadoPrincipalDiv.nativeElement.style.display = 'none';
        this.tabRouterDocumentacaoDiv.nativeElement.style.display = 'none';
        this.tabRouterEmpregadorDiv.nativeElement.style.display = 'none';
        this.tabRouterPagamentoDiv.nativeElement.style.display = 'none';
        this.tabRouterEstrangeiroDiv.nativeElement.style.display = 'none';
        if (typeof component == 'function') {
          if (!this.objAnexarDocumentos) {
            this.factoryAnexarDocumentos = this.resolver.resolveComponentFactory(component);
            this.tabRouterAnexarDocumentos.clear();
            this.objAnexarDocumentos = this.tabRouterAnexarDocumentos.createComponent(this.factoryAnexarDocumentos);
          }
        }
        break;
    }
  }

}
